import React from 'react'
import PropTypes from 'prop-types'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import Mosaic from './mosaic'

const selector = formValueSelector('widget')

export const AddMosaic = ({
  name,
  mediaId,
  duplicatesAllowed,
  duplication
}) => {
  return (
    <div className='col-xs-12'>
      <div className='row'>
        <Mosaic
          name={name}
          mediaId={mediaId}
          duplicatesAllowed={duplicatesAllowed}
          duplication={duplication}
        />
      </div>
    </div>
  )
}

AddMosaic.propTypes = {
  name: PropTypes.string,
  mediaId: PropTypes.array,
  duplicatesAllowed: PropTypes.bool,
  duplication: PropTypes.number
}

const AddMosaicField = connect((state, props) => ({
  mediaId: selector(state, 'mosaic.mediaId'),
  duplicatesAllowed: selector(state, 'mosaic.duplicatesAllowed'),
  duplication: selector(state, 'mosaic.duplication')
}))(AddMosaic)

export default AddMosaicField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/add-to-mosaic/index.js